<template>
  <main class="survey-page" aria-labelledby="page-title">
    <!-- Title -->
    <!-- <header class="page-head">
      <h1 id="page-title" class="title">최고경영진</h1>
      <p class="desc">각 문항에 대해 1(매우 미흡) ~ 5(매우 우수) 중 하나를 선택하고, 필요한 경우 추가 정보를 입력하세요.</p>
    </header> -->

    <!-- <header class="page-head">
      <h1 id="page-title" class="title">최고경영진</h1>
      <div class="desc">
        <p>
          조직의 <strong>내부통제 및 지배구조(Internal Control & Corporate Governance)</strong> 수준을 평가하기 위해,
          아래 각 영역과 항목을 신중히 검토하고 다음 기준에 따라 평가 점수를 부여하십시오.
        </p>

        <p>🔴 빨강 (Red): 해당 영역 또는 요인은 <strong>통제 및 지배구조 리스크를 수용 가능한 수준으로 낮추기 위해 상당한 보완과 개선이 필요한 상태</strong>를 의미합니다.
        </p>

        <p>🟡 노랑 (Yellow): 해당 영역 또는 요인은 <strong>일정 부분의 보완과 개선이 필요하여, 강화되지 않을 경우 리스크 수준이 상승할 수 있는 상태</strong>를 의미합니다.
        </p>

        <p>🟢 초록 (Green): 해당 영역 또는 요인은 <strong>충분히 효과적으로 운영되고 있으며, 통제 및 지배구조 리스크가 수용 가능한 최소 수준으로 유지되고 있는 상태</strong>를 의미합니다.
        </p>

        <p>&#8251; <strong>유의사항</strong> : 빨강(🔴) 또는 노랑(🟡)으로 평가된 모든 항목에는, 다음 점검 시 초록(🟢) 수준으로 개선하기 위한 <strong>구체적인 실행계획(Action Plan)</strong>을 작성해야 합니다.
        </p>
      </div>
    </header> -->

    <header class="page-head">
      <h1 id="page-title" class="title">최고경영진</h1>

      <div class="desc">
        <p>
          본 자가진단은 조직의 <strong>지배구조(Corporate Governance)</strong> 수준을 국제 기준에 따라 평가할 수 있도록 설계된 전문 진단 시스템입니다.
          내부감사인, 외부감사인, 감사위원회, 이사회, 최고경영진 등 핵심 지배구조 기능 5개 영역을 대상으로,
          각 기능별 역할과 운영 수준을 스스로 점검하고 개선 방향을 도출할 수 있도록 구성되어 있습니다.
        </p>

        <p>
          각 영역은 역할, 권한, 독립성, 윤리, 성과, 통제 수준, 보고 체계 등 국제 기준을 바탕으로 한 세부 평가 항목으로 구성되어 있어,
          조직의 지배구조 운영 상태를 객관적으로 확인할 수 있습니다.
        </p>

        <p>
          <strong>지배구조 자가점검을 통해 기대할 수 있는 효과</strong><br/>
          - 통제 미비 요소 및 개선 필요 사항을 <strong>신속하게 파악</strong><br/>
          - 조직의 내부통제·지배구조 수준을 <strong>국제 기준과 비교·평가</strong><br/>
          - 향후 내부통제 고도화, 인증, 외부 감사 대응을 위한 <strong>기초자료 확보</strong> 
        </p>

        <p>
          <strong>진단 방법 안내</strong><br/>
          조직의 <strong>지배구조</strong> 수준을 평가하기 위해, 아래 각 영역과 항목을 신중히 검토하고,
          현재 상황에 가장 맞는 답변을 <strong>‘예’ 또는 ‘아니오’</strong>로 선택해 주세요.
        </p>

        <p>
          •<strong>예 (Yes) </strong> : 해당 항목에 부합하거나 충족함<br/>
          •<strong>아니오 (No) </strong> : 해당 항목에 부합하지 않거나 충족하지 못함
        </p>

        <p>
          ※ <strong>유의사항</strong> :
          '아니오'로 평가한 모든 항목에 대해서는 다음 점검 시 효과적으로 운영되고 있는 수준으로 개선하기 위한
          <strong>구체적인 실행계획(Action Plan)</strong>을 작성해야 합니다.
        </p>

      </div>
    </header>

    <!-- 로딩/에러 -->
    <section v-if="loading" class="section"><p class="desc">질문을 불러오는 중…</p></section>
    <section v-else-if="error" class="section"><p class="desc" style="color:#b91c1c">{{ error }}</p></section>

    <!-- 섹션(기준) 렌더링 -->
    <section v-else v-for="(sec, si) in sections" :key="sec.key" class="section">
      <h2 class="section__title">{{ sec.title }}</h2>
      <p class="section__goal" v-if="sec.goal">목표: {{ sec.goal }}</p>

      <div class="t" role="table" :aria-label="`${sec.title} 설문 표`">
        <!-- Head -->
        <div class="t__head" role="row">
          <div class="th th--no" role="columnheader">구분</div>
          <div class="th th--q" role="columnheader">질문항목</div>
          <div class="th th--score" role="columnheader" aria-label="응답 점수">응답</div>
          <!-- <div class="th th--extra" role="columnheader">추가 필요 정보</div> -->
          <div class="th th--note" role="columnheader">비고</div>
        </div>

        <!-- Body -->
        <ul class="t__body">
          <!-- <li v-for="(q, qi) in sec.items" :key="q.key" class="tr" role="row">
            <div class="td td--no" role="cell">
              {{ sectionStartIndex[si] + qi + 1 }}
            </div>


            <div class="td td--q" role="cell">
              <label class="q-label" :for="idFor(si, qi, 's1')">{{ q.text }}</label>
            </div>

            <div class="td2 td--score" role="cell">
              <fieldset class="score-ryg" :aria-labelledby="idFor(si, qi, 'label')">
                <legend :id="idFor(si, qi, 'label')" class="sr-only">문항 색상 선택</legend>

                <label class="ryg">
                  <input
                    type="radio"
                    :name="`score-${si}-${qi}`"
                    :id="idFor(si, qi, `ryg-r`)"
                    value="1"
                    v-model="answers[q.key].score"
                    required
                  />
                  <span class="ryg__btn ryg__btn--red" aria-label="빨강(미흡)"></span>
                </label>

                <label class="ryg">
                  <input
                    type="radio"
                    :name="`score-${si}-${qi}`"
                    :id="idFor(si, qi, `ryg-y`)"
                    value="2"
                    v-model="answers[q.key].score"
                    required
                  />
                  <span class="ryg__btn ryg__btn--yellow" aria-label="노랑(보통)"></span>
                </label>

                <label class="ryg">
                  <input
                    type="radio"
                    :name="`score-${si}-${qi}`"
                    :id="idFor(si, qi, `ryg-g`)"
                    value="3"
                    v-model="answers[q.key].score"
                    required
                  />
                  <span class="ryg__btn ryg__btn--green" aria-label="초록(우수)"></span>
                </label>
              </fieldset>
            </div>

            <div class="td2 td--note" role="cell">
              <input type="text" class="input" placeholder="비고 입력" v-model.trim="answers[q.key].note" />
            </div>
          </li> -->
          <li v-for="(q, qi) in sec.items" :key="q.key" class="tr" role="row">
            <div class="td td--no" role="cell">
              {{ sectionStartIndex[si] + qi + 1 }}
            </div>

            <div class="td td--q" role="cell">
              <label class="q-label" :for="idFor(si, qi, 'yn-yes')">{{ q.text }}</label>
            </div>

            <!-- ✅ 점수: Yes / No -->
            <div class="td td--score" role="cell">
              <fieldset class="score-yn" :aria-labelledby="idFor(si, qi, 'label')">
                <legend :id="idFor(si, qi, 'label')" class="sr-only">
                  문항 평가 (Yes / No 선택)
                </legend>

                <!-- Yes -->
                <label class="yn">
                  <input
                    type="radio"
                    :name="`score-${si}-${qi}`"
                    :id="idFor(si, qi, 'yn-yes')"
                    :value="1"
                    v-model="answers[q.key].score"
                    required
                  />
                  <span class="yn__btn yn__btn--yes">Yes</span>
                </label>

                <!-- No -->
                <label class="yn">
                  <input
                    type="radio"
                    :name="`score-${si}-${qi}`"
                    :id="idFor(si, qi, 'yn-no')"
                    :value="0"
                    v-model="answers[q.key].score"
                    required
                  />
                  <span class="yn__btn yn__btn--no">No</span>
                </label>
              </fieldset>
            </div>

            <div class="td td--note" role="cell">
              <input
                type="text"
                class="input"
                placeholder="비고 입력"
                v-model.trim="answers[q.key].note"
              />
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- Submit -->
    <footer class="page-foot">
      <button class="btn-submit" type="button" @click="onSubmit">진단하기</button>
    </footer>
  </main>
</template>

<script setup>
import { reactive, ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex' 
import { selectSurveyList, updateSurvey  } from '@/api/survey'

// ▶ 이 설문 코드만 바꿔서 재사용 가능
const SURVEY_CODE = 'SURV001'

/**
 * 프론트 고정 매핑: sectionId → 기준/목표
 * sectionId는 API의 문자열/숫자 어느 쪽이 와도 대응하도록 key는 문자열로 둡니다.
 */
const CRITERIA_META = {
  '1': {
    title: '기업 비전 및 전략적 방향성',
    goal: '비전, 전략적 기획, 리더십이 경쟁력 있고 수익성 있는 조직을 창출하는지 평가.',
  },
  '2': {
    title: '윤리적 리더십',
    goal: '조직의 가치·윤리를 일상 운영에 반영하는 역할을 평가',
  },
  '3': {
    title: '비즈니스 프로세스 완결성',
    goal: '목표 달성을 위한 경영 프로세스의 완결성 평가',
  },
  '4': {
    title: '직원·고객·공급자와의 접근성',
    goal: '이해관계자와의 상호작용 및 경영진 참여도 평가',
  },
  '5': {
    title: '고객 및 이해관계자 중심',
    goal: '고객·주주·시장과의 관계 및 만족도 관리 평가',
  },
  '6': {
    title: '재무성과 및 사업성과',
    goal: 'CEO의 수익성·성장성·고객 만족도 달성 능력 평가',
  },
  '7': {
    title: '사회적 책임 및 지역사회 기여',
    goal: '기업의 사회적 책임, 윤리, 지역사회 기여 평가',
  },
}


const router = useRouter()
const store = useStore()
const checkUserId = computed(() => store.state.temp.userInfo)
const loading = ref(true)
const error = ref('')

const sections = ref([])
const answers = reactive({})

// ✅ 섹션별 시작 인덱스 (누적 번호 계산용)
const sectionStartIndex = computed(() => {
  const arr = []
  let acc = 0

  sections.value.forEach(sec => {
    arr.push(acc)              // 현재 섹션의 시작 번호
    acc += sec.items.length    // 다음 섹션 시작을 위해 누적
  })

  return arr                   // [0, 7, 14, ...] 이런 느낌
})

const idFor = (si, qi, suffix) => `q-${si}-${qi}-${suffix}`

// function hydrateAnswers() {
//   sections.value.forEach(sec => {
//     sec.items.forEach(q => {
//       if (!answers[q.key]) answers[q.key] = { score: null, extra: '', note: '' }
//     })
//   })
// }

// function hydrateAnswers() {
//   sections.value.forEach(sec => {
//     sec.items.forEach(q => {
//       const r = q.raw || {}
//       // API 점수/추가정보/비고가 있으면 그대로 주입, 없으면 기본값
//       if (!answers[q.key]) {
//         answers[q.key] = {
//           // score는 숫자로 강제 변환하되 값이 없으면 null 유지
//           score: r.score === 0 || r.score ? Number(r.score) : null,
//           extra: r.addInfo ?? '',
//           note:  r.note ?? '',
//         }
//       } else {
//         // 이미 값이 있다면(사용자가 수정 중이었다면) API 값이 있을 때만 보수적으로 덮어쓰기 원하면 아래 주석 해제
//         // if (r.score === 0 || r.score) answers[q.key].score = Number(r.score)
//         // if (r.addInfo != null) answers[q.key].extra = r.addInfo
//         // if (r.note != null)    answers[q.key].note  = r.note
//       }
//     })
//   })
// }

function hydrateAnswers() {
  sections.value.forEach(sec => {
    sec.items.forEach(q => {
      const r = q.raw || {}

      if (!answers[q.key]) {
        let initialScore = null

        // 🔹 실제로 저장된 응답만 복원 (status === 'SAVED' && score 0/1)
        if (r.status === 'SAVED' && (r.score === 0 || r.score === 1)) {
          initialScore = Number(r.score)
        } else {
          // 최초 진입 / 기본값 등은 전부 미선택
          initialScore = null
        }

        answers[q.key] = {
          score: initialScore,     // 0, 1, 또는 null
          extra: r.addInfo ?? '',
          note : r.note ?? '',
        }
      }
    })
  })
}

function groupBySection(rawList) {
  const map = new Map()
  rawList.forEach(row => {
    const sid = String(row.sectionId ?? '')
    if (!map.has(sid)) map.set(sid, [])
    map.get(sid).push(row)
  })

  // 각 섹션 7문항 기준으로 정렬/제한
  for (const [sid, arr] of map) {
    arr.sort((a, b) => (Number(a.id) || 0) - (Number(b.id) || 0))
    map.set(sid, arr.slice(0, 7))
  }

  // 섹션 배열로 변환 + 프론트 고정 기준/목표 주입
  const keys = [...map.keys()].sort((a, b) => Number(a) - Number(b))
  return keys.map(sid => {
    const meta = CRITERIA_META[sid] || { title: `기준 ${sid}`, goal: '' }
    const rows = map.get(sid) || []
    return {
      key: `sec_${sid}`,
      title: meta.title,
      goal: meta.goal,
      items: rows.map(r => ({
        key: r.questionCode,   // v-model 키(서버 코드와 매핑)
        text: r.queItem,       // 질문 텍스트
        raw: r,                // 원본(제출시 활용)
      })),
    }
  })
}

async function fetchSurvey() {
  try {
    loading.value = true
    error.value = ''
    const result = await selectSurveyList({ surveyCode: SURVEY_CODE, userId : checkUserId.value?.userId })
    // 응답: { result: 'ok', data: [...] }
    if (!result || result.result !== 'ok' || !Array.isArray(result.data)) {
      throw new Error('잘못된 응답 형식')
    }
    sections.value = groupBySection(result.data)
    hydrateAnswers()
  } catch (e) {
    console.error(e)
    error.value = '질문을 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

async function onSubmit() {
  // 1) 사용자 ID 확보 (없으면 방어)
  const uid = checkUserId.value?.userId
  if (!uid) {
    alert('로그인 정보가 없습니다. 다시 로그인 해 주세요.')
    return
  }

  // 2) 서버로 보낼 payload 배열 구성
  const payload = []
  sections.value.forEach(sec => {
    sec.items.forEach(q => {
      const a = answers[q.key] || {}
      payload.push({
        userId: uid,
        surveyCode: SURVEY_CODE,
        sectionId: String(q.raw.sectionId ?? ''),   // 기준별 id
        questionCode: q.key,                        // 질문 코드
        score: (a.score === 0 || a.score === 1) ? Number(a.score) : null,
        addInfo: a.extra || '',                     // 추가 필요 정보
        note: a.note || '',                         // 비고
        status: 'SAVED',                            // 명세 값
      })
    })
  })

  try {
    loading.value = true
    const res = await updateSurvey(payload)
    const total = payload.reduce((s, x) => s + (x.score || 0), 0)
    const avg = payload.length ? total / payload.length : 0
    const snapshot = {
      surveyCode: SURVEY_CODE,
      form: 'audit-committee',
      submittedAt: new Date().toISOString(),
      totalScore: total,
      averageScore: avg,
      items: sections.value.flatMap(sec =>
        sec.items.map(q => {
          const ans = answers[q.key] || {}
          const rawScore = ans.score

        return {
          sectionId: q.raw.sectionId,
          sectionTitle: sec.title,
          questionCode: q.key,
          queItem: q.text,
          // score: answers[q.key]?.score ?? null,
          score: (rawScore === 0 || rawScore === 1) ? rawScore : null,
          // addInfo: answers[q.key]?.extra || '',
          note: answers[q.key]?.note || ''
        }
        })
      ),
    }
    sessionStorage.setItem('audit-committee-survey', JSON.stringify(snapshot))

    alert('설문이 저장되었습니다.')
    router.push('/surveyresult')
  } catch (e) {
    console.error(e)
    alert('설문 저장 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.')
  } finally {
    loading.value = false
  }
}

function restoreFromSnapshot() {
  const raw = sessionStorage.getItem('audit-committee-survey')
  if (!raw) return

  try {
    const snap = JSON.parse(raw)

    // 다른 설문 코드랑 섞이지 않도록 체크
    if (snap.surveyCode !== SURVEY_CODE) return
    if (!Array.isArray(snap.items)) return

    // questionCode → score 매핑
    const scoreMap = new Map(
      snap.items.map(it => [it.questionCode, it.score])
    )

    sections.value.forEach(sec => {
      sec.items.forEach(q => {
        const savedScore = scoreMap.get(q.key)

        // 저장된 값이 있으면 그대로 덮어쓰기 (0, 1, null 모두 허용)
        if (savedScore === 0 || savedScore === 1 || savedScore === null) {
          if (!answers[q.key]) {
            answers[q.key] = {
              score: savedScore,
              extra: q.raw.addInfo ?? '',
              note: q.raw.note ?? '',
            }
          } else {
            answers[q.key].score = savedScore
          }
        }
      })
    })
  } catch (e) {
    console.error('snapshot 복원 실패', e)
  }
}


onMounted(async () => {
  await fetchSurvey()   // 서버 데이터로 sections, answers 기본 세팅
  hydrateAnswers()      // 기존 로직 그대로 유지

  // 🔥 서버가 null을 0으로 바꿔버려도, 우리가 저장해 둔 snapshot으로 최종 덮어쓰기
  restoreFromSnapshot()
})
</script>

<style scoped>
/* ====== 기본 레이아웃/폰트 규격 ====== */
.survey-page {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 20px;
  padding: 20px 16px 40px;
  background: #fff;
  font-family: 'Noto Sans KR', sans-serif;
}

/* 타이틀 규격 */
.title { font-size: 1.625rem; font-weight: 700; }

/* 설명글(p) 규격 */
.desc, .section__goal, .t .td p { font-size: 0.95rem; }

.page-head { 
  display: grid; 
  gap: 8px; 
  margin-bottom: 20px;
}

.title { 
  font-size: 1.625rem; 
  font-weight: 700; 
}

.desc strong {
  font-weight: 700;
}

.desc p { 
  font-size: 0.95rem; 
  line-height: 1.65;
  margin-bottom: 10px;
  /* text-wrap: pretty; */
  word-break: keep-all;
}
.section { display: grid; gap: 12px; }
.section__title { font-size: 1.125rem; font-weight: 700; }

/* ====== 표(Grid) ====== */
.t { display: grid; gap: 0; border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden; }
.t__head {
  display: grid;
  grid-template-columns: 72px 1fr 280px 260px 220px;
  background: #0f172a;
  color: #fff;
}
.th { padding: 12px 12px; font-weight: 700; }
.t__body { display: grid; gap: 0; }
.tr {
  display: grid;
  grid-template-columns: 72px 1fr 280px 260px 220px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}
.td { padding: 12px; display: flex; align-items: center; }
.td2 {padding: 12px; display: flex; align-items: center; justify-content: center;}
.td--no { justify-content: center; color: #6b7280; }
.td--q { align-items: center; }
.q-label { line-height: 1.6; 
  /* text-wrap: pretty;  */
}

/* 점수 라디오 */
.score { display: grid; grid-auto-flow: column; gap: 8px; justify-content: center; align-items: center; }
.radio { display: grid; place-items: center; }
.radio input { position: absolute; opacity: 0; width: 0; height: 0; }
.radio__mark {
  display: inline-flex; width: 36px; height: 36px; border-radius: 50%;
  align-items: center; justify-content: center;
  border: 1px solid #d1d5db; background: #f9fafb; font-weight: 600;
  user-select: none; cursor: pointer;
}
.radio input:checked + .radio__mark {
  background: #1d2088; color: #fff; border-color: #1d2088;
}

/* 입력 필드 */
.input {
  width: 100%; min-height: 38px; padding: 8px 10px; border: 1px solid #e5e7eb;
  border-radius: 8px; font-size: 0.95rem;
}
.input:focus { outline: 2px solid #1d2088; outline-offset: 1px; }

/* 제출 영역 */
.page-foot { display: grid; gap: 10px; justify-items: center; margin-top: 8px; }
.btn-submit {
  padding: 12px 18px; border-radius: 10px; background: #1d2088; color: #fff;
  font-weight: 700; cursor: pointer; border: 1px solid #1d2088;
}
.btn-submit:hover { filter: brightness(0.95); }

/* 반응형 */
@media (max-width: 1200px) {
  .t__head, .tr { grid-template-columns: 60px 1fr 240px 220px 200px; }
}
@media (max-width: 992px) {
  .t__head, .tr { grid-template-columns: 52px 1fr 200px 1fr 1fr; }
}
@media (max-width: 768px) {
  .t__head { display: none; }
  .tr { grid-template-columns: 1fr; gap: 8px; border-top: 1px solid #e5e7eb; padding: 10px 12px; }
  .td--no { justify-content: flex-start; font-weight: 700; }
  .td--q { order: 2; }
  .td--score { order: 3; }
  .td--extra { order: 4; }
  .td--note { order: 5; }
  .td { padding: 0; }
  .score { justify-content: flex-start; }
}

/* 스크린리더 전용 텍스트 */
.sr-only {
  position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
  overflow: hidden; clip: rect(0,0,0,0); white-space: nowrap; border: 0;
}

/* ====== 표(Grid) ====== */
.t { display: grid; gap: 0; border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden; }

/* 헤더/행: 4컬럼 = [번호 | 질문 | 응답버튼 | 비고] */
.t__head {
  display: grid;
  grid-template-columns: 72px 1fr 200px 250px;
  background: #0f172a;
  color: #fff;
  justify-items: center;
}
.th { padding: 12px 12px; font-weight: 700; }

.t__body { display: grid; gap: 0; }
.tr {
  display: grid;
  grid-template-columns: 72px 1fr 200px 250px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}
.td { padding: 12px; display: flex; align-items: center; }
.td--no { justify-content: center; color: #6b7280; }
.td--q { align-items: center; }
.q-label { line-height: 1.6; }


/* 점수(색상) 라디오 */
/* .score-ryg {
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.ryg { display: grid; place-items: center; }
.ryg input { position: absolute; opacity: 0; width: 0; height: 0; }

.ryg__btn {
  display: inline-flex;
  align-items: center; justify-content: center;
  min-width: 10px; height: 10px;
  padding: 12px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  font-size: 0.95rem;
  font-weight: 700;
  user-select: none; cursor: pointer;
  transition: transform .06s ease, box-shadow .12s ease, background .12s ease, color .12s ease, border-color .12s ease;
}

.ryg__btn--red    { background: #fee2e2; border-color: #fecaca; color: #b91c1c; }
.ryg__btn--yellow { background: #fef3c7; border-color: #fde68a; color: #b45309; }
.ryg__btn--green  { background: #dcfce7; border-color: #bbf7d0; color: #047857; }

.ryg input:checked + .ryg__btn--red    { background: #ef4444; border-color:#ef4444; color:#fff; }
.ryg input:checked + .ryg__btn--yellow { background: #f59e0b; border-color:#f59e0b; color:#111; }
.ryg input:checked + .ryg__btn--green  { background: #10b981; border-color:#10b981; color:#fff; }

.ryg input:focus + .ryg__btn { outline: 2px solid #1d2088; outline-offset: 2px; }

.ryg__btn:hover { filter: brightness(.98); }
.ryg input:active + .ryg__btn { transform: scale(.98); } */
@media (max-width: 1200px) {
  .t__head, .tr { grid-template-columns: 60px 1fr 260px 200px; }
}
@media (max-width: 992px) {
  .t__head, .tr { grid-template-columns: 52px 1fr 220px 1fr; }
}
@media (max-width: 768px) {
  .t__head { display: none; }
  .tr { grid-template-columns: 1fr; gap: 10px; border-top: 1px solid #e5e7eb; padding: 12px; }
  .td { padding: 0; }
  .td--no { justify-content: flex-start; font-weight: 700; order: 1; }
  .td--q { order: 2; }
  .td--score { order: 3; }
  .td--note { order: 4; }
  .score-ryg { justify-content: flex-start; }
}


/* 짝수행 배경색 */
.t__body .tr:nth-child(even) {
  background: #f7f7f7; /* 너무 진하지 않은 옅은 회색 */
}


/* 회원 전용 안내 상자 */
.member-note {
  background: #f5f5f5;
  padding: 16px 18px;
  border-radius: 6px;
  margin-bottom: 16px;
}

.member-note p {
  margin-bottom: 8px;
}

/* ===== Yes / No 라디오 버튼 ===== */
/* ===== Yes / No 심플 버튼 ===== */
.score-yn {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.yn {
  position: relative;
  display: flex;
  align-items: center;
}

.yn input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.yn__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: 
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}

/* Hover */
.yn__btn:hover {
  background: #f3f4f6;
}

/* Focus */
.yn input:focus + .yn__btn {
  outline: 2px solid #93c5fd; /* light blue */
  outline-offset: 2px;
}

/* 체크된 버튼 (심플 파란색 강조) */
.yn input:checked + .yn__btn {
  background: #eff6ff;    /* 아주 연한 파란색 */
  border-color: #3b82f6;  /* 파란 보더 */
  color: #1e3a8a;         /* 진파랑 글씨 */
}

</style>
